import { useLayoutEffect, useRef, useState } from 'react'

// A fixed-width document (the 960 px PDF layout of an RA, review, report) shown scaled down to the width of its box, so a phone or a
// narrow dialog never scrolls it sideways; it scrolls only up and down. At full width (box >= width) it is shown 1:1.
export default function FitHtml({ html, width = 960, style, className, label }) {
  const box = useRef(null), inner = useRef(null)
  const [fit, setFit] = useState({ scale: 1, height: null })
  useLayoutEffect(() => {
    const el = box.current
    if (!el) return undefined
    const measure = () => {
      const scale = Math.min(1, (el.clientWidth || width) / width)
      const height = inner.current ? Math.ceil(inner.current.offsetHeight * scale) : null
      setFit(f => (f.scale === scale && f.height === height ? f : { scale, height }))
    }
    measure()
    if (typeof ResizeObserver === 'undefined') return undefined
    const ro = new ResizeObserver(measure)
    ro.observe(el); if (inner.current) ro.observe(inner.current)
    return () => ro.disconnect()
  }, [html, width])
  return (
    <div ref={box} className={className} role={label ? 'document' : undefined} aria-label={label} style={{ overflowX: 'hidden', overflowY: 'auto', ...style }}>
      <div style={{ position: 'relative', width: '100%', height: fit.height != null ? fit.height : 'auto', overflow: 'hidden' }}>
        <div ref={inner} style={{ width, transform: fit.scale < 1 ? 'scale(' + fit.scale + ')' : 'none', transformOrigin: '0 0' }} dangerouslySetInnerHTML={{ __html: html }} />
      </div>
    </div>
  )
}
